import React, { useEffect, useState } from 'react';
import KitLoader from '../../components/kitsters/KitLoader';
import TableItem from "./TableItem"
import { getdatanoauth, WAITINGGIF, sendwhatsappmessageapi } from '../../util/global';

const ItemVendorCheck = () => {
  const [loading, setLoading] = useState(true);
  const [vendoritemdata, setvendoritemdata] = useState([]);

  const params = new URLSearchParams(window.location.search);
  const fetchdata = async () => {
    const adminuserid = window.APPUSER?.user?.token ? window.APPSETTING.adminuserid : params.get('adminuserid');

    let data = await getdatanoauth({ zohodatatype: 'items', _adminuserid: adminuserid, tag:"checkvendor" }, '/zohodatanoauth');
    setvendoritemdata(data.data);
    setLoading(false);
  };

  useEffect(() => {
   fetchdata();
  }, []);

  return (

    <div className="content-area" style={{ position: 'relative', minHeight: 'calc(100vh - 140px)' }}>
      {loading && <KitLoader />}

      <h3 style={{ marginBottom: '16px' }}>Vendor Check | Problem Count: {vendoritemdata.length} </h3>
      <TableItem itemdata={vendoritemdata} />

    </div>
  );
};

export default ItemVendorCheck;
